import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import { App } from '@/App'
import { ApiError } from '@/lib/api'
import '@/index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Данные дашбордов не должны молча перезапрашиваться при каждом
      // переключении вкладки: пользователь ожидает, что цифры меняются
      // только по кнопке обновления или после нового импорта
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      retry: (failureCount, error) => {
        // Повторять бессмысленно, если сервер сказал «нет прав» или «не найдено»
        if (error instanceof ApiError && error.status < 500) return false
        return failureCount < 2
      },
    },
    mutations: { retry: false },
  },
})

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Не найден элемент #root')

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
)
